import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG, MENU_FORECAST_ID } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { MultiSelect } from 'primereact/multiselect';
import lodash from 'lodash';

const MAX_GENERATED_ROWS = 2000;

const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        dateFormat={field.dateFormat}
        view={field.view}
        metaData={metaData}
    /> || null;
};

const norm = s => String(s || '').trim().toLowerCase();

class AddMenuForecast extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            payslipGenerated: false,
            stageSequence: 0,
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments: [],
        };
    }

    isEmptyValue = (val) => val === null || val === undefined || (Array.isArray(val) ? val.length === 0 : String(val).trim() === '');

    isRowDisabled = (stageIndex) => {
        const { tableLists = {}, location = {} } = this.props;
        const { stageSequence } = this.state;
        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pendingWith = location.state && location.state.pendingWith;
        return (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false;
    }

    handleChange = (e) => {
        e.preventDefault();
        const { name } = e.target;
        let { value } = e.target;
        if (Array.isArray(value)) value = value.join(',');

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage =>
            Object.assign({}, { ...stage }, {
                stage_Field: stage.stage_Field.map(field =>
                    field.fieldName === name ? Object.assign({}, { ...field }, { fieldValue: value }) : field)
            }));

        this.setState({ process: updatedProcess, payslipGenerated: false });
    }

    handleMultiSelectChange = (e) => {
        const { name, value } = e.target;
        const fieldValue = Array.isArray(value) ? value.join(',') : value;

        const updatedProcess = this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
            stage_Field: stage.stage_Field.map(field =>
                Object.assign({}, { ...field }, { fieldValue: field.fieldName === name ? fieldValue : field.fieldValue })
            )
        }));

        this.setState({ process: updatedProcess, payslipGenerated: false });
    }

    containerCellTemplate = (rowData, columnField, disabled) => {
        const fieldInstance = (rowData.fields || []).find(f => f.fieldId === columnField.fieldId) || {};
        const metaData = this.props.metaData || {};
        const onInputChange = (e) => this.handleChange(e);

        if ((fieldInstance.fieldStatus || columnField.fieldStatus) === 'Display Only') {
            const match = metaData[columnField.fieldDescription] && fieldInstance.fieldValue && metaData[columnField.fieldDescription].find(o => o.value === fieldInstance.fieldValue);
            const displayValue = (match && match.label) || (['7', '8'].includes(String(columnField.fieldType)) && fieldInstance.fieldValue && moment.utc(fieldInstance.fieldValue).format('MM/DD/YYYY')) || fieldInstance.fieldValue || '';
            return <span>{displayValue}</span>;
        }

        switch (String(columnField.fieldType)) {
            case '2':
                return <Dropdown name={fieldInstance.fieldName} value={fieldInstance.fieldValue} options={metaData[columnField.fieldDescription] || []} placeholder={columnField.fieldDescription} disabled={disabled} onChange={onInputChange} style={{ width: '100%' }} {...DROPDOWN_CONFIG} />;
            case '3':
                return <MultiSelect name={fieldInstance.fieldName} value={fieldInstance.fieldValue ? fieldInstance.fieldValue.split(',') : []} options={metaData[columnField.fieldDescription] || []} placeholder={columnField.fieldDescription} disabled={disabled} onChange={(e) => this.handleMultiSelectChange(e)} filter className="p-col-12" {...DROPDOWN_CONFIG} />;
            case '7':
            case '8': {
                // Show the stored UTC calendar day as a local date, and store the picked day back as UTC midnight,
                // so the selected day never shifts with the browser timezone.
                const stored = fieldInstance.fieldValue ? moment.utc(fieldInstance.fieldValue) : null;
                const selected = stored && stored.isValid() ? new Date(stored.year(), stored.month(), stored.date()) : null;
                const onDateChange = (e) => this.handleChange({
                    preventDefault: () => { },
                    target: { name: fieldInstance.fieldName, value: e.value ? moment.utc(moment(e.value).format('YYYY-MM-DD')).toISOString() : null }
                });
                // only use the field's own format when it is a PrimeReact format (moment-style tokens break the picker)
                const dateFormat = columnField.dateFormat && !/[A-Z]/.test(columnField.dateFormat) ? columnField.dateFormat : undefined;
                return <Calendar name={fieldInstance.fieldName} value={selected} dateFormat={dateFormat} placeholder={columnField.fieldDescription} disabled={disabled} onChange={onDateChange} appendTo={document.body} style={{ width: '100%' }} readOnlyInput showIcon />;
            }
            default:
                return <InputText name={fieldInstance.fieldName} value={fieldInstance.fieldValue || ''} placeholder={columnField.fieldDescription} disabled={disabled} onChange={onInputChange} style={{ width: '100%' }} />;
        }
    }

    containerActionTemplate = (rowData, field, rowCount) => {
        return <Button icon="pi pi-trash" className="p-button-danger" disabled={rowCount <= 1} onClick={() => this.removeContainerRow(field, rowData.childRowNmbr)} />;
    }

    removeContainerRow = (field, childRowNmbr) => {
        const { process, stageSequence } = this.state;
        const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
            stage_Field: stage.stage_Field.filter(el => !(el.parentFieldId === field.fieldName && el.childRowNmbr === childRowNmbr))
        }));
        this.setState({ process: updatedProcess });
    }

    // Add Row: clones the first row of the container as a blank row. Existing rows are untouched.
    handleContainer = (field) => {
        const { process, stageSequence } = this.state;
        const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
            if (stageIndex !== 0) return stage;
            const stageField = arraySort(stage.stage_Field, 'fieldSequence');
            const groups = lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr');
            const keys = Object.keys(groups);
            if (keys.length === 0) return stage;
            const templateFields = groups[keys[0]];
            // max + 1 (not count) so a row added after a delete never collides with an existing row number
            const nextRow = Math.max(...keys.map(k => parseInt(k, 10) || 0)) + 1;
            let count = stageField.length + 1;
            let sequence = stageField.length + 1;
            const newFields = templateFields.map(el => Object.assign({}, { ...el }, {
                fieldName: `${el.fieldName.substring(0, 10)}${count++}`,
                fieldSequence: sequence++,
                childRowNmbr: nextRow.toString(),
                parentFieldId: field.fieldName,
                fieldValue: el.fieldType == 1 ? '' : null
            }));
            return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
        });
        this.setState({ process: updatedProcess });
    }

    findContainerField = (stageField, childFieldDescription) =>
        stageField.find(f => f.fieldType === '9' && stageField.some(sf => sf.parentFieldId === f.fieldName && sf.fieldDescription === childFieldDescription));

    // Menu Item (multiselect) x day in [From, To] -> one container row per combination.
    generate = () => {
        const stageField = arraySort(this.state.process[0].stage_Field, 'fieldSequence');
        const header = stageField.filter(f => f.parentFieldId === '000' && f.fieldType !== '9');
        // Labels are matched first; otherwise fall back to field types (multiselect = menu items, date fields = from / to).
        const dateHeaders = header.filter(f => ['7', '8'].includes(String(f.fieldType)));
        const menuItemField = header.find(f => norm(f.fieldDescription) === 'menu item') || header.find(f => /menu\s*item/i.test(f.fieldDescription || '') && String(f.fieldType) === '3') || header.find(f => String(f.fieldType) === '3');
        const fromField = header.find(f => norm(f.fieldDescription) === 'forecast from date') || dateHeaders.find(f => /from/i.test(f.fieldDescription || '')) || dateHeaders[0];
        const toField = header.find(f => norm(f.fieldDescription) === 'forecast to date') || dateHeaders.find(f => /\bto\b/i.test(f.fieldDescription || '')) || dateHeaders.find(f => f !== fromField);
        const containerField = this.findContainerField(stageField, 'Menu Item') || stageField.find(f => f.fieldType === '9' && f.parentFieldId === '000');

        if (!menuItemField || !fromField || !toField || !containerField) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Menu Item, Forecast From Date, Forecast To Date and the detail container must be configured on this process' });
            return;
        }

        const requestDateField = header.find(f => norm(f.fieldDescription) === 'request date');
        const missing = [];
        if (requestDateField && this.isEmptyValue(requestDateField.fieldValue)) missing.push(requestDateField.fieldDescription || 'Request Date');
        if (this.isEmptyValue(menuItemField.fieldValue)) missing.push(menuItemField.fieldDescription || 'Menu Item');
        if (this.isEmptyValue(fromField.fieldValue)) missing.push(fromField.fieldDescription || 'Forecast From Date');
        if (this.isEmptyValue(toField.fieldValue)) missing.push(toField.fieldDescription || 'Forecast To Date');
        if (missing.length > 0) {
            this.setState({ requiredFieldsMessage: `Please fill in the following required fields: ${missing.join(', ')}.` });
            return;
        }

        // A picked date is a local Date; a value loaded from a saved request is a UTC string. Either way keep the same calendar day.
        const toCalendarDay = v => {
            if (v instanceof Date) return moment(v).startOf('day');
            const u = moment.utc(v);
            return moment([u.year(), u.month(), u.date()]);
        };
        const start = toCalendarDay(fromField.fieldValue);
        const end = toCalendarDay(toField.fieldValue);
        if (start.isAfter(end)) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Forecast From Date cannot be later than Forecast To Date' });
            return;
        }

        const menuItems = lodash.uniq(String(menuItemField.fieldValue).split(',').map(v => v.trim()).filter(Boolean));
        const days = [];
        for (let d = start.clone(); !d.isAfter(end); d.add(1, 'day')) {
            // date at UTC midnight so the selected calendar day does not shift by timezone
            days.push(moment.utc(d.format('YYYY-MM-DD')).toISOString());
        }
        if (menuItems.length * days.length > MAX_GENERATED_ROWS) {
            this.growl.show({ severity: 'error', summary: null, detail: `Too many rows (${menuItems.length * days.length}). Please reduce menu items or the date range` });
            return;
        }

        const groups = lodash.groupBy(stageField.filter(f => f.parentFieldId === containerField.fieldName), 'childRowNmbr');
        const templateFields = groups[Object.keys(groups)[0]] || [];
        const dateColumn = templateFields.find(f => ['7', '8'].includes(String(f.fieldType)));
        const menuColumn = templateFields.find(f => /menu\s*item/i.test(f.fieldDescription || '')) || templateFields.find(f => ['2', '3'].includes(String(f.fieldType)));
        if (!dateColumn || !menuColumn) {
            this.growl.show({ severity: 'error', summary: null, detail: 'The detail container needs a Menu Item column and a date column' });
            return;
        }

        let count = stageField.length + 1;
        let sequence = stageField.length + 1;
        let rowIndex = 0;
        const newFields = [];
        menuItems.forEach(menuItem => {
            days.forEach(day => {
                templateFields.forEach(tf => {
                    let value = tf.fieldType == 1 ? '' : null;
                    if (tf.fieldId === menuColumn.fieldId) value = menuItem;
                    else if (tf.fieldId === dateColumn.fieldId) value = day;
                    newFields.push(Object.assign({}, { ...tf }, {
                        fieldName: `${tf.fieldName.substring(0, 10)}${count++}`,
                        fieldSequence: sequence++,
                        childRowNmbr: rowIndex.toString(),
                        parentFieldId: containerField.fieldName,
                        fieldValue: value
                    }));
                });
                rowIndex++;
            });
        });

        const updatedProcess = this.state.process.map((s, idx) => idx === 0 ? Object.assign({}, { ...s }, {
            stage_Field: s.stage_Field.filter(f => f.parentFieldId !== containerField.fieldName).concat(newFields)
        }) : s);

        this.setState({ process: updatedProcess });
        this.growl.show({ severity: 'success', summary: null, detail: `${rowIndex} row(s) generated` });
    }

    handleAttachment = (data) => {
        const { loggedUserDetail } = this.props;
        const attachmentData = data.map((el, index) => ({
            Requestattachmentid: '00000000-0000-0000-0000-000000000000',
            Requestid: '00000000-0000-0000-0000-000000000000',
            SiNo: index + 1,
            UploadPath: el.filePath,
            FileName: el.fileName,
            Extension: el.fileExtension,
            Createdby: loggedUserDetail.empID,
            Createddate: moment().format('MM/DD/YYYY'),
            Updatedby: loggedUserDetail.empID,
            Updateddate: moment().format('MM/DD/YYYY'),
            CompanyId: loggedUserDetail.CompanyId,
            Stagenum: 0,
        }));
        this.setState({ requestattachments: attachmentData });
    }

    initialize = (process, type) => {
        const { stageSequence } = this.state;
        const pageType = this.props.match.params.type;
        const pendingWith = this.props.location && this.props.location.state && this.props.location.state.pendingWith;
        const { tableLists, location = {} } = this.props;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;

        let count = 1;
        let sequence = 1;
        this.setState({ process: [], loading: true });

        const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
            const stageField = arraySort(stage.stage_Field, 'fieldSequence');
            const disabled = (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false;
            return Object.assign({}, { ...stage }, {
                stage_Field: stageField.reduce((a, el) => {
                    const startIndex = el.fieldName.substring(0, 10);
                    if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                    } else if (type === 'add' && el.fieldType === '9') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        const lastItem = a[a.length - 1];
                        stageField.filter(_ => _.parentFieldId === el.fieldName).forEach(subField => {
                            a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                        });
                    } else if (type === 'edit') {
                        a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        const lastItem = a[a.length - 1];
                        if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                            el.stage_FieldsList.forEach((subField, subIndex) => {
                                if (subIndex != 0) {
                                    subField.stage_FieldsListc2.forEach(c2 => {
                                        a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                    });
                                }
                            });
                        }
                    }
                    return a;
                }, [])
            });
        });

        setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;

        const RequestAttributes = [];
        process.forEach(stage => {
            stage.stage_Field.forEach(el => {
                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === '7' || el.fieldType === '8') && el.fieldValue ? moment.utc(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            });
        });

        if (submitType === 'save' || submitType === 'submit') {
            const missingFields = [];
            const shown = process.filter((p, i) => i <= parseInt(this.state.stageSequence));
            shown.forEach(stage => {
                (stage.stage_Field || []).forEach(el => {
                    if (el.fieldStatus !== 'Required' || el.parentFieldId !== '000' || el.fieldType === '9') return;
                    if (!el.fieldDescription || !ImplementationFor[parseInt(el.fieldType)]) return;
                    if (this.isEmptyValue(el.fieldValue) && !missingFields.includes(el.fieldDescription)) missingFields.push(el.fieldDescription);
                });
            });

            // every container row must have its required columns filled
            const rowErrors = [];
            shown.forEach(stage => {
                const fields = stage.stage_Field || [];
                fields.filter(el => el.fieldType === '9' && el.parentFieldId === '000').forEach(container => {
                    const grouped = lodash.groupBy(fields.filter(_ => _.parentFieldId === container.fieldName), 'childRowNmbr');
                    Object.keys(grouped).forEach(key => {
                        grouped[key].forEach(sub => {
                            if (sub.fieldStatus === 'Required' && sub.fieldDescription && this.isEmptyValue(sub.fieldValue) && !rowErrors.includes(sub.fieldDescription)) {
                                rowErrors.push(sub.fieldDescription);
                            }
                        });
                    });
                });
            });

            if (missingFields.length > 0 || rowErrors.length > 0) {
                const lines = [];
                if (missingFields.length > 0) lines.push(`Please fill in the following required fields: ${missingFields.join(', ')}.`);
                if (rowErrors.length > 0) lines.push(`Please fill in the following detail columns in every row: ${rowErrors.join(', ')}.`);
                this.setState({ requiredFieldsMessage: lines.join('\n') });
                return;
            }
        }

        const data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Restaurant Menu Forecast Request',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: '',
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: MENU_FORECAST_ID,
            RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };

        if (!(process && process.length > 0)) return;

        const levelId = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
        let model = 'requestSave';
        if (submitType === 'submit') {
            if (this.state.DynamicSupervisor) {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
            }

            model = 'RFO';
        }

        if (submitType === 'delegate') {
            if (this.state.DynamicSupervisor) data.DynamicSupervisor = this.state.DynamicSupervisor;
            data.Delegate_WF_Level_ID = levelId;
            model = 'RFO';
        }

        if (submitType === 'forward') {
            if (this.state.DynamicSupervisor) data.DynamicSupervisor = this.state.DynamicSupervisor;
            data.Forward_WF_Level_ID = levelId;
            model = 'RFO';
        }

        if (submitType === 'return') {
            if (this.state.DynamicSupervisor) data.DynamicSupervisor = this.state.DynamicSupervisor;
            if (this.state.DynamicSupervisor) {
                const SelDropdownEmployee = (this.state.DynamicSupervisorsList || []).find(el => el.value === this.state.DynamicSupervisor);
                data.Return_WF_Level_ID = levelId;
                data.Return_to_WF_Level_ID = SelDropdownEmployee && SelDropdownEmployee.Request_WF_LEVEL_ID;
            }
            model = 'RFO';
        }

        if (type === 'edit' && this.state.requestId) {
            data.requestId = this.state.requestId;
        }

        const datas = { Key: JSON.stringify(data) };

        let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

        if (submitType === 'submit') {
            url = '/master/api/workflow/submit?type=' + model;
        } else if (submitType === 'reject') {
            url = '/master/api/workflow/reject?type=RFO';
        } else if (submitType === 'delegate') {
            url = '/master/api/workflow/delegate?type=' + model;
        } else if (submitType === 'forward') {
            url = '/master/api/workflow/forward?type=' + model;
        } else if (submitType === 'return') {
            url = '/master/api/workflow/return?type=' + model;
        } else if (submitType === 'cancel') {
            url = '/master/api/workflow/cancel?type=RFO';
        }

        this.setState({ loading: true });
        axios.post(url, JSON.stringify(datas))
            .then(response => {
                this.setState({ loading: false });
                if (submitType === 'submit' || submitType === 'return') {
                    if (response.status === 200) {
                        if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                            const submitValue = response.data.result && JSON.parse(response.data.result);
                            let tableValue = [];
                            if (submitValue.Table && submitValue.Table.length > 0) {
                                tableValue = submitValue.Table.map(list => ({ label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }));
                            }
                            this.setState({
                                dialogBoxText: submitType === 'return' ? 'Return To' : 'Select Supervisor',
                                popupType: submitType === 'return' ? 'return' : this.state.popupType,
                                requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue
                            });
                        } else {
                            this.growl.show({ severity: 'success', summary: null, detail: 'Menu Forecast request submitted successfully' });
                            this.props.history.push('/dashboard');
                        }
                    } else {
                        this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                    }
                } else {
                    this.growl.show({ severity: 'success', summary: null, detail: 'Menu Forecast request saved successfully' });
                    this.props.history.push('/dashboard');
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            });
    }

    componentDidMount() {
        const { getContainerData, getMasterKeywordList, location = {} } = this.props;
        const type = this.props.match.params.type;
        getContainerData(MENU_FORECAST_ID);//Get Container Data

        getMasterKeywordList('Employee');
        getMasterKeywordList('MenuItem');
        getMasterKeywordList('UOM');
        getMasterKeywordList('Branch');
        getMasterKeywordList('resMealPeriod');
        getMasterKeywordList('branch');
        getMasterKeywordList('MenuItem');
        getMasterKeywordList('resMealPeriod');
        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const pageType = this.props.match.params.type;
            this.setState({ requestattachments: (tableLists && tableLists.requestattachments) || [] });

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (pageType === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                const full = pageType === 'edit' && process.length > 0 && process.concat(container.filter((c, i) => i > (process.length - 1))) || process;
                this.setState({ stageSequence, requestId, initialData: full });
                setTimeout(() => this.initialize(full, pageType === 'edit' ? 'edit' : 'add'), 3000);
                clearInterval(interval);
            }
        }, 300);
    }

    render() {
        const { metaData = {} } = this.props;
        const { process, stageSequence } = this.state;
        const actionRowStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' };
        const dialogDynamicFooter = (
            <div style={actionRowStyle}>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary" />
            </div>
        );

        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Restaurant Menu Forecast
                            <Link to={'/menuforecast'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={this.props.location && this.props.location.state && this.props.location.state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    const disabled = this.isRowDisabled(stageIndex);
                    const isRemarkField = f => f.parentFieldId === '000' && f.fieldType !== '9' && /^remarks?$/i.test(String(f.fieldDescription || '').trim());
                    const remarkField = stageIndex === 0 ? stageField.find(isRemarkField) : null;
                    const generateButton = <div className="p-col-12 p-md-6 p-lg-4">
                        <label className="label">&nbsp;</label>
                        <div className="mt1">
                            <Button label="Generate" className="p-button-info" disabled={disabled} onClick={this.generate} />
                        </div>
                    </div>;

                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    if (field.parentFieldId !== '000') return null;
                                    const containerGroup = field.fieldType === '9' && lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr') || false;
                                    const containerColumns = (containerGroup && Object.values(containerGroup).reduce((best, grp) => grp.length > best.length ? grp : best, [])) || [];
                                    const containerRows = (containerGroup && Object.keys(containerGroup).map(row => ({
                                        childRowNmbr: row,
                                        parentFieldId: field.fieldName,
                                        fields: containerGroup[row]
                                    }))) || [];

                                    return <React.Fragment key={fieldIndex}>
                                        <div className={field.fieldType === '9' || (field.fieldType === '6' && !(remarkField && field.fieldName === remarkField.fieldName)) ? 'p-col-12' : 'p-col-12 p-md-6 p-lg-4'}>
                                            {field.fieldType !== '9' ? <Inputs
                                                field={field}
                                                value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(',') : field.fieldValue}
                                                process={process}
                                                onInputChange={this.handleChange}
                                                {...this.props}
                                                {...this.state} /> :
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? false : this.state[field.fieldName]} onToggle={(e) => this.setState({ [field.fieldName]: e.value })}>
                                                    <div className="p-grid">
                                                        <div className="p-col-12" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            <Button disabled={disabled} className="p-button-success" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add Row" />
                                                        </div>
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                                dataKey="childRowNmbr" paginator rows={10} value={containerRows}>
                                                                {containerColumns.map((columnField, columnIndex) =>
                                                                    <Column key={columnIndex} header={columnField.fieldDescription} body={(rowData) => this.containerCellTemplate(rowData, columnField, disabled)} />
                                                                )}
                                                                {disabled ? null : <Column body={(rowData) => this.containerActionTemplate(rowData, field, containerRows.length)} header="Action" style={{ textAlign: 'center', width: '8em' }} />}
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset>}
                                        </div>
                                        {remarkField && field.fieldName === remarkField.fieldName ? generateButton : null}
                                    </React.Fragment>;
                                })}

                                {stageIndex === 0 && !remarkField ? generateButton : null}

                                {stageIndex > 0 ?
                                    <div className="p-col-12" style={actionRowStyle}>
                                        <Button disabled={disabled} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Approve" icon="pi pi-save" />
                                        <Button disabled={disabled} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger" />
                                        <Link to={'/menuforecast'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    <div className="p-col-12" style={actionRowStyle}>
                                        <Button disabled={disabled} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                                        <Button disabled={disabled} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                                        <Link to={'/menuforecast'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>;
                })}

                <Dialog header="Required Fields" visible={!!this.state.requiredFieldsMessage} modal={true} style={{ width: '400px' }} closable={true}
                    footer={<Button label="Close" icon="pi pi-times" className="p-button-secondary" onClick={() => this.setState({ requiredFieldsMessage: '' })} />}
                    onHide={() => this.setState({ requiredFieldsMessage: '' })}>
                    <p style={{ whiteSpace: 'pre-line', fontWeight: 'normal' }}>{this.state.requiredFieldsMessage}</p>
                </Dialog>

                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })} {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;

    let relevantOptions = [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) a.push(el);
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }

    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData,
        Employee,
        EmployeeList: relevantOptions,
        metaData: Object.assign({}, {
            'Requested For': relevantOptions,
            'Menu Item': state.keyword.MenuItem || [],
            'Unit': state.keyword.UOM || [],
            'Uom': state.keyword.UOM || [],
            'Restaurant': state.keyword.Branch || [],
            'Meal Type': state.keyword.resMealPeriod || [],
            'Outlet': state.keyword.branch || [],
            'Select Menu Item': state.keyword.MenuItem || [],
            'Meal Period': state.keyword.resMealPeriod || [],
        })
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMenuForecast);
